import { Loader } from '../common'
import ReshipmentItem from './ReshipmentItem'
import { getReshipmentSummaryStatusProps } from '../../selectors/reshipment'
import { convertTitleCase } from '../../utils/common'

const mapStateToProps = (state, ownProps) => {
  const { data, testWindow, itemOrder = [] } = ownProps
  const {
    app: {
      breakpoint: { name: breakpointName },
    },
  } = state
  const { fetching } = getReshipmentSummaryStatusProps(state)
  return {
    fetching,
    data,
    testWindow,
    itemOrder,
    breakpointName,
  }
}

const ReshipmentSummaryForTestWindow = ({
  fetching,
  data = {},
  testWindow,
  itemOrder,
  breakpointName,
}) => {
  const ancillaryCds = Object.keys(data)

  if (fetching) {
    return <Loader />
  }

  if (ancillaryCds.length === 0) {
    return <p>No items have been ordered for {convertTitleCase(testWindow)} window.</p>
  }

  return (
    <>
      {itemOrder.map(ancillaryCd => (
        <ReshipmentItem
          data={data[ancillaryCd] || {}}
          key={ancillaryCd}
          breakpoint={breakpointName}
        />
      ))}
    </>
  )
}

export default connect(mapStateToProps, null)(ReshipmentSummaryForTestWindow)
